import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogClickResetFilter = () => {
  return useCallback(() => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_REFRESH',
      analytics: {
        SCREEN: 'MARKET_RANKING',
      },
    });
  }, []);
};
